/**
 * @generated SignedSource<<e0810a048e33397ea8a3163ccbd5329a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectBudgetDays_project$data = {
  readonly account: {
    readonly default_full_time_minutes: number;
    readonly id: number;
  };
  readonly budget_method: any;
  readonly id: number;
  readonly phases: ReadonlyArray<{
    readonly id: number;
    readonly phase_roles: ReadonlyArray<{
      readonly estimated_minutes: number | null | undefined;
      readonly id: number;
      readonly phase_id: number | null | undefined;
      readonly role_id: number;
    }>;
  }>;
  readonly project_roles: ReadonlyArray<{
    readonly estimated_minutes: number | null | undefined;
    readonly id: number;
    readonly role_id: number;
  }>;
  readonly summary: ReadonlyArray<{
    readonly role_id: number | null | undefined;
    readonly total_billable_minutes: number | null | undefined;
    readonly total_nonbillable_minutes: number | null | undefined;
  }>;
  readonly " $fragmentType": "ProjectBudgetDays_project";
};
export type ProjectBudgetDays_project$key = {
  readonly " $data"?: ProjectBudgetDays_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectBudgetDays_project">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role_id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimated_minutes",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectBudgetDays_project",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "budget_method",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "accounts",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "default_full_time_minutes",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "v_summary_total",
      "kind": "LinkedField",
      "name": "summary",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "total_billable_minutes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "total_nonbillable_minutes",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "project_roles",
      "kind": "LinkedField",
      "name": "project_roles",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "phases",
      "kind": "LinkedField",
      "name": "phases",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "phase_roles",
          "kind": "LinkedField",
          "name": "phase_roles",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "phase_id",
              "storageKey": null
            },
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "projects",
  "abstractKey": null
};
})();

(node as any).hash = "1cda62514f73d74445263fc848ef21af";

export default node;
